/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type BudgetPage_company = {
    readonly tier: TierType | null;
    readonly " $fragmentRefs": FragmentRefs<"BudgetPageHeader_company" | "BudgetData_company" | "Details_company">;
    readonly " $refType": "BudgetPage_company";
};
export type BudgetPage_company$data = BudgetPage_company;
export type BudgetPage_company$key = {
    readonly " $data"?: BudgetPage_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BudgetPage_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPage_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetPageHeader_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetData_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Details_company"
    }
  ],
  "type": "Company"
};
(node as any).hash = 'b7d7f1135250d55dc50983cf868a5ec3';
export default node;
